export default {
  "fullscreen-split": "_fullscreen-split_jww68e",
  "content": "_content_jww68e",
  "illustration": "_illustration_jww68e",
  "title": "_title_jww68e",
  "description": "_description_jww68e",
  "actions": "_actions_jww68e"
};